import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en';
import es from './locales/es';

const resources = { en, es };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    // Only the languages the app ships: a browser in another language (e.g. vi-VN) gets the fallback as its
    // language as well, so what is keyed by language (the tenant's field labels) matches what is shown
    supportedLngs: Object.keys(resources),
    nonExplicitSupportedLngs: true,
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
